<template>
    <v-simple-table dense :loading="loading">
        <thead>
            <tr>
                <th>{{$t('JOB_NUMBER')}}</th>
                <th>{{ $t('ENTER_DATE') }}</th>
                <th>{{$t('EXIT_DATE')}}</th>
                <th>{{ $t('MALFACTIONS_CLASSFICATIONS') }}</th>

            </tr>
        </thead>
        <tbody>
            <tr v-for="job in data" :key="job.id" @click="handelClick(job.id)">
                <td>{{job.code}}</td>
                <td>{{job.date_enter}}</td>
                <td>{{job.leave_date}}</td>
                <td>
                    <ul>
                        <li v-for="failure in job.failures" :key="failure.id">{{failure.description}}</li>
                    </ul>
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    props:{
        data:[Array,String],
        loading:Boolean
    },
    methods:{
        handelClick(id) {
            this.$emit('openJobCard', id)
        }
    }

}
</script>

<style>

</style>